import * as React from "react";
import type { SVGProps } from "react";

const ChartiSymbol = ({ color = "#004df9", ...props }: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 160 160" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g transform="translate(-25, -5)">
      <path
        fill={color}
        d="M76.87,88.44v15.07l24.34-13.49h5.78c12.29,0,22.45-9.41,23.13-21.44.03-.51.04-1.03.04-1.56h-13.72c0,.27,0,.53-.02.78-.26,4.68-4.5,8.48-9.43,8.48h-9.33l-11.85,6.57h-.17v-6.86c-9.19,0-16.66-7.48-16.66-16.66,0-10.37,8.44-18.82,18.82-18.82h42.38v-13.72h-42.38c-17.94,0-32.54,14.6-32.54,32.54,0,13.71,9.12,25.33,21.62,29.1Z"
      />
      <rect fill={color} x="85.4" y="48.95" width="9.47" height="9.47" />
      <rect fill={color} x="102.26" y="48.95" width="9.47" height="9.47" />
      <path
        fill={color}
        d="M144.32,36.98c-.58-.76-1.46-1.28-2.49-1.34-1.13-.07-2.38-.07-3.73,0-1.87.08-3.32,1.67-3.24,3.54.08,1.87,1.67,3.32,3.54,3.24,1.11-.05,2.13-.05,3.02,0,.12,0,.24,0,.36,0,1.02-.05,1.91-.56,2.5-1.32h7.83v20.96c0,9.83-2.46,19.6-7.1,28.25-3.28,6.11-7.92,11.23-13.45,15.14l-2.14-2.91c-9.6,7.07-20.99,10.81-32.95,10.81s-23.35-3.74-32.95-10.81l-2.14,2.91c-5.53-3.91-10.17-9.03-13.45-15.14-4.65-8.66-7.1-18.43-7.1-28.25v-20.96h5.49c.59.76,1.48,1.28,2.5,1.32.12,0,.24,0,.36,0,.89-.05,1.91-.05,3.02,0,1.87.08,3.46-1.36,3.54-3.24.08-1.87-1.36-3.46-3.24-3.54-1.35-.06-2.6-.06-3.73,0-1.03.06-1.91.58-2.49,1.34h-9.57v25.08c0,10.5,2.62,20.95,7.59,30.2,3.57,6.66,8.62,12.25,14.63,16.51l-1.11,1.51c11.26,8.3,24.63,12.68,38.65,12.68s27.39-4.39,38.65-12.68l-1.11-1.51c6.01-4.26,11.06-9.85,14.63-16.51,4.97-9.25,7.59-19.7,7.59-30.2v-25.08h-11.91Z"
      />
    </g>
  </svg>
);

export default ChartiSymbol;
